import { useContext } from "react";
import TickerContext from "../contexts/tickerContext";

const useTickerContext = () => {
  const context = useContext(TickerContext);
  return context;
};

export { useTickerContext };
